import { render, staticRenderFns } from "./SidebarCreateReportPreviewComponent.vue?vue&type=template&id=9bf87f50&scoped=true&"
import script from "./SidebarCreateReportPreviewComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarCreateReportPreviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarCreateReportPreviewComponent.vue?vue&type=style&index=0&id=9bf87f50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf87f50",
  null
  
)

export default component.exports